<template>
  <div
    class="icon"
    :style="{
      width: `${$attrs.size}px`,
      height: `${$attrs.size}px`,
      backgroundImage: `url('/icons/${$attrs.name}.png')`,
    }"
  ></div>
</template>

<script>
export default {};
</script>

<style scoped>
.icon {
  background-size: cover;
  background-position: center;
}
</style>
